import React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import styled from "styled-components";

const StyledButton = styled(Button)(() => ({
    ':hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.12)',
      },
}));


export default function ControlButton(props) {

    const disabledIcon = React.cloneElement(props.children,  {style: {fill: "grey"}} )
    const enabledIcon = React.cloneElement(props.children,  {style: {fill: "white"}} )

    return (
        <React.Fragment>
            
            {props.disabled ?
                <Box 
                    minWidth="39px"
                    minHeight="39px"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    px="2px"
                >
                    <StyledButton 
                        onClick={ props.clicked } 
                        disabled={ props.disabled }
                        style={{maxWidth:"39px", 
                                maxHeight:"39px", 
                                minWidth:"39px", 
                                minHeight:"39px"}} 
                        value="left"
                        aria-label="left aligned">
                            { disabledIcon }
                    </StyledButton>
                </Box>
                : <Tooltip 
                    title={ props.title } 
                    arrow>
                    <Box 
                        minWidth="39px"
                        minHeight="39px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        px="2px"
                    >
                        <StyledButton 
                            onClick={ props.clicked } 
                            disabled={ props.disabled }
                            style={{
                                maxWidth:"39px", 
                                maxHeight:"39px", 
                                minWidth:"39px", 
                                minHeight:"39px"
                            }} 
                            value="left"
                            aria-label="left aligned">
                                { enabledIcon }
                        </StyledButton>
                    </Box>
                </Tooltip>
            }
        </React.Fragment>
    )
}